export default {
  data() {
    return {
      assignment: null,
      recordingType: 'assignment',
      devFormData: {},
    };
  },
  computed: {
    preferences() {
      return this.$store.getters.preferences;
    },
    videoEnabled() {
      const org = this.$store.getters.org;
      return (org && typeof org.settings !== 'undefined' && org.settings.Video);
    },
    isFreeTrial() {
      return !!(this.user && this.user.metadata && this.user.metadata.freeTrial);
    },
    assignments: {
      cache: false,
      get() {
        return this.$store.getters.assignedAssignments;
      }
    },
    assignmentsEnabled() {
      const org = this.$store.getters.org;
      return (org && typeof org.settings !== 'undefined' && org.settings.Assignments);
    },
    showAssignmentSelect() {
      return !!(this.assignmentsEnabled && !this.$router.currentRoute.query.assignmentId);
    },
    hasBothAlgorithms: {
      cache: false,
      get() {
        const algorithms = this.$store.getters.org.algorithmConfig.algorithms;
        let hasSingle, hasMulti;
        algorithms.forEach((algo) => {
          if (algo.name.indexOf('default') !== -1) hasSingle = true;
          if (algo.name.indexOf('conversational') !== -1) hasMulti = true;
        });
        return !!(hasSingle === true && hasMulti === true);
      }
    },
    showAlgorithmSelect: {
      cache: false,
      get() {
        return this.hasBothAlgorithms &&
          (!this.assignment || !(this.assignment.criteria && this.assignment.criteria.algorithm));
      }
    },
    user() {
      return this.$store.getters.user;
    },
    myAssignmentRecordings: {
      cache: false,
      get() {
        const recs = [];
        if (this.assignment && this.assignment.recordings && this.assignment.recordings.length) {
          this.assignment.recordings.forEach((rec) => {
            if (rec.userId == this.user.userId) {
              recs.push(rec);
            }
          });
        }
        return recs;
      }
    }
  },
  methods: {
    populateAssignmentAndTitle() {
      if (!this.assignmentsEnabled) {
        return;
      }

      if (this.$router.currentRoute.query.assignmentId) {
        this.assignment = this._.find(this.assignments, (a) => a.assignmentId === this.$router.currentRoute.query.assignmentId);
      }
      this.assignmentChosen({assignment: this.assignment, recordingType: this.recordingType});
    },
    sharingChanged(formValues) {
      this.formValues.submitted = formValues.submitted;
      this.formValues.feedbackRequested = formValues.feedbackRequested;
    },
    getAssignmentId() {
      if (this.assignmentsEnabled) {
        if (this.$router.currentRoute.query.assignmentId) {
          return this.$router.currentRoute.query.assignmentId;
        } else if (this.assignment) {
          return this.assignment.assignmentId;
        }
      }
    },
    addRecordingToAssignment(recordingId) {
      if (!this.assignmentsEnabled) {
        return;
      }

      const assignmentId = this.getAssignmentId();
      if (assignmentId) {
        this.$store.dispatch(
          'addRecordingToAssignment',
          { assignmentId, recordingId }
        );
      }
    },
    algorithmChosen(algoArgs) {
      if (algoArgs === true && this.assignment && this.assignment.criteria &&
        this.assignment.criteria.algorithm) {
        // Set algo based on assignment-select
        this.formValues.algorithm = this.assignment.criteria.algorithm;
      }
      if (algoArgs.algorithm) {
        // Set algo based on speaker-select
        this.formValues.algorithm = algoArgs.algorithm;
      }
    },
    assignmentChosen(assignmentArgs) {
      this.assignment = assignmentArgs.assignment;
      this.recordingType = assignmentArgs.recordingType;

      if (assignmentArgs.assignment) {
        this.formValues.title = this.getDefaultTitle();
        this.formValues.assignment = assignmentArgs.assignment;
      } else {
        this.formValues.title = '';
        this.formValues.submitted = false;
        this.formValues.feedbackRequested = false;
        this.formValues.assignment = null;
      }
      this.algorithmChosen(true);
    },
    getDefaultTitle() {
      let maxNum = 0;
      for (let i=1; i<1001; i++) {
        const title = this.assignment.name.length > 42 ?
          this.assignment.name.substr(0, 41) + '...- v' + i :
          this.assignment.name + ' - v' + i;
        const exists = this._.find(this.$store.getters.recordings, (rec) => {
          return !!(rec.title.indexOf(title) !== -1);
        });
        if (exists) {
          maxNum = i;
        }
      }

      maxNum++;
      return this.assignment.name.length > 42 ?
        this.assignment.name.substr(0, 41) + '...- v' + maxNum :
        this.assignment.name + ' - v' + maxNum;
    },
    getFormData() {
      const assignmentId = this.getAssignmentId();
      let _fv = this._.cloneDeep(this.formValues);

      let formData = (_fv.source === 'ui upload form') ?
        new FormData() : { trim: {} };

      // Generic assignment function
      const _assign = (_val, _name) => {
        // Do not send null values
        if (!_val) return;

        if (typeof formData.append !== 'undefined') {
          // Manually JSON-encode, as needed
          if (_name === 'diarization' || _name === 'transcription' || _name === 'metadata') {
            _val = JSON.stringify(_val);
          }
          formData.append(_name, _val);
        } else {
          if (_name === 'trim[from]') {
            formData.trim.from = _val;
          } else if (_name === 'trim[to]') {
            formData.trim.to = _val;
          } else {
            formData[_name] = _val;
          }
        }
      };

      // To assign trim, we first delete the old values
      if (_fv.trim) {
        _assign(_fv.trim.from, 'trim[from]');
        _assign(_fv.trim.to, 'trim[to]');
        delete _fv.trim;
      }

      // Assign all of formValues to formData
      this._.forEach(_fv, _assign);

      // Add our debug data
      ['language', 'orgGroup', 'metadata', 'diarization', 'transcription', 'wordspotting', 'operations', 'transcriptionWebhook', 'vvAnalysisWebhook', 'videoTrimmingWebhook'].forEach((field) => {
        if (this.devFormData[field]) {
          _assign(this.devFormData[field], field);
        }
      });

      // Add the audio
      if (_fv.source === 'ui upload form') {
        formData.append('audio', this.$refs.fileInput.files[0]);
      }
      if (_fv.source === 'ui record form') {
        formData.audio = this.mediaFile;
      }
      if (_fv.source === 'zoom form') {
        formData.audio = this.activeRecordings[this.downloadUrlIdx].download_url;
      }

      // Add assignments and groupIds
      if (assignmentId) {
        _assign(assignmentId, 'assignmentId');

        // Set the groupId
        const assignment = _.find(
          this.assignments,
          {assignmentId}
        );
        if (assignment && assignment.groupId) {
          _assign(assignment.groupId, 'groupId');
        }
      } else if (this.selectedGroup) {
        _assign(this.selectedGroup.groupId, 'groupId');
      }

      return formData;
    },
    recordingUploaded(recordingId, formData) {
      const algorithm = formData.get ? formData.get('algorithm') : formData.algorithm;

      if (recordingId && algorithm  && algorithm.indexOf('conversational') !== -1) {
        // We need to hide video mode by default for all conversational recordings
        // We cant tell if something is a video or not so we hide it regardless
        this.$store.dispatch(
          'updatePreferences',
          Object.assign(this.preferences, {[recordingId]: {hideVideo: true}})
        );
      }

      this.$router.push({ name: 'evaluate-recording', params: { recordingId } });
    },
    loadDevFormData(devFormData) {
      // Clear out old items
      ['language', 'orgGroup', 'metadata', 'diarization', 'transcription', 'wordsToSpot'].forEach((field) => {
        this.devFormData[field] = null;
      });
      this.devFormData = devFormData;
    }
  }
};
